var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconInfoBlue = function SvgIconInfoBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 23.667C18.4398 23.667 23.6665 18.4403 23.6665 12.0003C23.6665 5.56032 18.4398 0.333656 11.9998 0.333655C5.55984 0.333655 0.33317 5.56032 0.333169 12.0003C0.333168 18.4403 5.55984 23.667 11.9998 23.667ZM11.9998 10.8337C12.6415 10.8337 13.1665 11.3587 13.1665 12.0003L13.1665 16.667C13.1665 17.3087 12.6415 17.8337 11.9998 17.8337C11.3582 17.8337 10.8332 17.3087 10.8332 16.667L10.8332 12.0003C10.8332 11.3587 11.3582 10.8337 11.9998 10.8337ZM10.8332 6.16699L13.1665 6.16699L13.1665 8.50032L10.8332 8.50032L10.8332 6.16699Z",
    fill: "#2EA3F2"
  })));
};

export default __webpack_public_path__ + "static/media/IconInfoBlue.00c28841.svg";
export { SvgIconInfoBlue as ReactComponent };